import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';

// Singleton QueryClient - NICHT in Komponente erstellen!
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Quiz-Daten ändern sich selten während einer Session
      staleTime: 1000 * 60 * 5, // 5 Minuten
      gcTime: 1000 * 60 * 10,   // 10 Minuten (v5: umbenannt von cacheTime)

      // Retry-Strategie
      retry: (failureCount, error: Error & { response?: { status?: number } }) => {
        // Keine Wiederholung bei Auth/NotFound
        if (error?.response?.status === 401 || error?.response?.status === 404) {
          return false;
        }
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

      // PWA-optimiert
      refetchOnWindowFocus: false,  // Quiz-State nicht verlieren
      refetchOnReconnect: true,     // Nach Offline → Online neu laden
      networkMode: 'offlineFirst',  // Kritisch für PWA
    },
    mutations: {
      retry: 1,
      networkMode: 'offlineFirst',
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      // Nur Toast wenn wir bereits Daten hatten (Background-Refetch fehlgeschlagen)
      if (query.state.data !== undefined) {
        console.error('[QueryCache] Background update failed:', error);
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      console.error('[MutationCache] Mutation failed:', error);
    },
  }),
});
